import gql from 'graphql-tag';

export default gql`
query listFA_HistoryDeleted($id: ID!, $languageId: Int, $params: ListQueryArgs){
  fakturaAssist{
    listFA_HistoryDeleted(id: $id, languageId: $languageId, params: $params){
		id
		recordID
		newValueID
		dOperation
		operationName
		userFullName
		fieldName
		oldValue
		newValue
		content
		formTypeName
		dbFieldName
		dbFieldType
    }
  }
}`;
